import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { ActorService } from '../../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController } from '../../../../../models/actor/actor';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { AppFeaturesList } from '../../../../../constants/constants';
import { routerTransition } from '../../../../../animations/router.animations';
//import  './profilesteps.js';



@Component({
  selector: 'myprofessionalreference',
  templateUrl: './myprofessionalreference.component.html',
  styleUrls: ['./myprofessionalreference.component.scss']
  , animations: [routerTransition()]
})

export class MyProfessionalReferencesComponent implements OnInit{


  public isRequesting: boolean = false;

  public ApiResData: ApiResponseModel;

  @Input() ActorCode: number = 0;


  //
  public IsSetAccessRights: boolean;




  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;


  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {


    if (this.ActorCode <= 0) {
      this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }


    this.onSetFeatureAccessConfig();



 


  }

  

  onSetFeatureAccessConfig() {


   

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())



    //

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }


    this.IsSetAccessRights = true;





    //
  }
  //

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }




}
